import { financeNames } from "../../../../constants";

export const financeTypesInfo = {
  [financeNames.businessFinance]: [
    { key: 1, text: "Collateral Free", islamicText: "Collateral Free", iconName: "balance" },
    {
      key: 2,
      text: "Finance amount up to AED 3 Million*",
      islamicText: "Finance amount up to AED 3 Million*",
      iconName: "availability"
    },
    {
      key: 3,
      text: "Up to 60 months repayment period*",
      islamicText: "Up to 60 months payment period*",
      iconName: "repayment"
    },
    {
      key: 4,
      text: "Express loans up to AED 500,000*",
      islamicText: "Express finance up to AED 500,000*",
      iconName: "expressLoan"
    }
  ],
  [financeNames.capitalFinance]: [
    {
      key: 1,
      text: "Working Capital Finance up to 35mio*",
      islamicText: "Working Capital Finance up to 35mio*",
      iconName: "twcFinance"
    },
    {
      key: 2,
      text: "Multiple Trade Finance products with swift processing",
      islamicText: "Multiple Trade Finance products with swift processing",
      iconName: "financeProducts"
    },
    {
      key: 3,
      text: "Dedicated Relationship Manager",
      islamicText: "Dedicated Relationship Manager",
      iconName: "relationshipManager"
    },
    {
      key: 4,
      text: "TWC Express up to AED 1mio*",
      islamicText: "TWC Express up to AED 1mio*",
      iconName: "twcExpress"
    }
  ],
  [financeNames.assetBasedFinance]: [
    {
      key: 1,
      text: "Financing of heavy Equipment, medical Equipment, commercial vehicles/fleet and more",
      islamicText:
        "Financing of heavy Equipment, medical Equipment, commercial vehicles/fleet and more",
      iconName: "financingHeavyEquipment"
    },
    {
      key: 2,
      text: "Finance amounts of up to AED 35mio*",
      islamicText: "Finance amounts of up to AED 35mio*",
      iconName: "financeAmounts"
    },
    {
      key: 3,
      text: "Competitive pricing",
      islamicText: "Competitive pricing",
      iconName: "competitivePricing"
    },
    {
      key: 4,
      text: "Flexible Repayment up to 48 months",
      islamicText: "Flexible Payment up to 48 months",
      iconName: "flexibleRepayment"
    }
  ]
};

export const financeText = {
  [financeNames.businessFinance]: {
    title: "Expand your business with unmatched loan features",
    islamicTitle: "Expand your business with unmatched finance features"
  },
  [financeNames.capitalFinance]: {
    title: "Solutions catering to all your requirements",
    islamicTitle: "Solutions catering to all your requirements"
  },
  [financeNames.assetBasedFinance]: {
    title: "Wide range of advantages on finance for a broad range of assets",
    islamicTitle: "Wide range of advantages on finance for a broad range of assets"
  }
};
